interface Props {
  label: string;
  customStyles?: React.CSSProperties;
}

export default function ListLoading({ label, customStyles }: Props) {
  const styles = {
    borderRadius: '0.475rem',
    boxShadow: '0 0 50px 0 rgb(82 63 105 / 15%)',
    margin: '0',
    width: 'auto',
    padding: '1rem 3rem',
    top: '15%',
    left: 'calc(50% - 5.5rem)',
    ...customStyles,
  };

  return (
    <div
      className='position-absolute bg-white text-center text-dark fs-5 fw-bold'
      style={{ ...styles }}
    >
      {label}
    </div>
  );
}
